var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0404 9.04048C14.4309 8.64996 14.4309 8.01679 14.0404 7.62627C13.6499 7.23574 13.0167 7.23574 12.6262 7.62627L14.0404 9.04048ZM9.99996 11.6667L9.29285 12.3738C9.48039 12.5614 9.73474 12.6667 9.99996 12.6667C10.2652 12.6667 10.5195 12.5614 10.7071 12.3738L9.99996 11.6667ZM7.37373 7.62627C6.98321 7.23574 6.35004 7.23574 5.95952 7.62627C5.56899 8.01679 5.56899 8.64996 5.95952 9.04048L7.37373 7.62627ZM12.6262 7.62627L9.29285 10.9596L10.7071 12.3738L14.0404 9.04048L12.6262 7.62627ZM10.7071 10.9596L7.37373 7.62627L5.95952 9.04048L9.29285 12.3738L10.7071 10.9596Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIcon);
export default __webpack_public_path__ + "static/media/arrow-down-icon.28830da4fb026c0272df3b13fa651850.svg";
export { ForwardRef as ReactComponent };